/**
 * TanStack Query hooks for the saved plots API.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchPlots,
  createPlot,
  deletePlot,
  type SavedPlot,
  type SavedPlotPayload,
} from "../api/plots";

export function useSavedPlots(projectId: string, branch: string) {
  return useQuery<SavedPlot[]>({
    queryKey: ["saved-plots", projectId, branch],
    queryFn: () => fetchPlots(projectId, branch),
    enabled: !!projectId,
  });
}

export function useCreatePlot(projectId: string, branch: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: SavedPlotPayload) => createPlot(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["saved-plots", projectId, branch] });
      qc.invalidateQueries({ queryKey: ["provenance", projectId] });
    },
  });
}

export function useDeletePlot(projectId: string, branch: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (plotId: string) => deletePlot(plotId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["saved-plots", projectId, branch] });
      qc.invalidateQueries({ queryKey: ["provenance", projectId] });
    },
  });
}
